import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

export const Folder = styled(Box)(
  ({ theme, isImage }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${isImage ? "120px" : "80px"};
  padding: 0 5px;
  height: fit-content;
  border-radius: 5px;
  word-break: break-word;
  :hover {
    cursor: pointer;
    background-color: ${theme.palette.mode === "dark" ? "#505050" : "#d5d5d5"};
  }
  img {
    max-width: 100%;
  }
  p {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`
);

export const Container = styled("div")`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const DropzoneContainer = styled("div")`
  height: 100%;
  width: 100%;
`;

export const InputContainer = styled("div")`
  height: 100%;
  width: 100%;
`;

export const StyledInput = styled("input")`
  height: 100%;
  width: 100%;
  visibility: "hidden";
`;

export const FolderContainer = styled("div")`
  position: absolute;
  top: 0;
  width: 100%;
`;

export const UploadDocument = styled("div")`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed black;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 3;
  backdrop-filter: blur(2px);
`;

export const FolderName = styled(Typography)`
  margin-top: 2px;
  max-width: 80px;
  overflow: hidden;
  padding-bottom: 1px;
  line-height: 1.2;
  text-align: center;
  height: auto;
  margin-bottom: 2px;
`;

export const Document = styled(Typography);
